import { useEffect } from 'react';

import type React from 'react';

import { setClass } from '../../helpers/utils';
import './styles.scss';

type ModalConfirmProps = {
	className?: string;
	sizeWidth?: string;
	overModal?: boolean;
	children?: React.ReactNode;
	alertMode?: boolean;
};

export const ModalConfirm = ({
	className = '',
	sizeWidth = '',
	overModal = false,
	children,
	alertMode,
}: ModalConfirmProps) => {
	const styles = {
		width: sizeWidth,
	};

	useEffect(() => {
		document.body.classList.add('fixed');
		return () => {
			if (!overModal) {
				document.body.classList.remove('fixed');
			}
		};
	}, [overModal]);

	return (
		<div
			className={setClass(`modal
        ${className}`)}
		>
			<div className="modal__child" style={styles}>
				{children}
			</div>
		</div>
	);
};
